"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultUnsubscribeState = void 0;
var UnsubscribeTranslate_init_1 = require("@/pages/unsubscribe/states/UnsubscribeTranslate.init");
var UserSearchSet_init_1 = require("@/pages/common/states/UserSearchSet.init");
exports.defaultUnsubscribeState = {
    t: UnsubscribeTranslate_init_1.defaultUnsubscribeTranslate,
    deletePopupActive: true,
    confirmPopupActive: false,
    allChecked: false,
    newsletterChecked: false,
    downloadDataChecked: false,
    followingsSearchSets: [UserSearchSet_init_1.defaultUserSearchSetFollowDistrictType],
    savedSearchesSearchSets: UserSearchSet_init_1.defaultUserSearchSets,
    isLoading: false,
};
